export const Amreli = {
    title: "Amreli",
    title1: "(Cultural and Historical City)",

    intro: "Amreli, a city in the Saurashtra region of Gujarat, is known for its rich cultural heritage, historical significance, and natural beauty. It is often referred to as the 'Cultural Capital of Saurashtra' and is home to ancient temples, wildlife sanctuaries, and vibrant traditions.",

    attractions: [
        {
            name: "Nagnath Temple",
            description: "A historic temple dedicated to Lord Shiva, Nagnath Temple is one of the most revered religious sites in Amreli. The temple's architecture reflects the ancient craftsmanship of Gujarat and attracts devotees and tourists alike.",
            location: "Amreli City Center, Amreli",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening during festivals",
            activities: [
                "Offer prayers to Lord Shiva",
                "Admire the temple's architecture",
                "Attend the evening Aarti",
                "Explore the temple surroundings",
                "Participate in religious festivals"
            ],
            mapLink: "https://maps.app.goo.gl/1zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Amreli Gir Interpretation Zone",
            description: "A unique wildlife attraction, this zone offers an opportunity to learn about the flora and fauna of the Gir Forest, including the Asiatic lion. It is an educational and recreational spot for nature enthusiasts.",
            location: "Near Amreli, Gujarat",
            timings: "9:00 AM to 6:00 PM",
            ticket: "INR 50 for adults, INR 20 for children",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Learn about the Gir Forest ecosystem",
                "Observe wildlife exhibits",
                "Take guided tours",
                "Capture photographs",
                "Enjoy the natural surroundings"
            ],
            mapLink: "https://maps.app.goo.gl/2zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Khodiyar Mata Temple",
            description: "A popular temple dedicated to Goddess Khodiyar, this site is known for its spiritual significance and vibrant festivals. The temple attracts devotees from across Gujarat and beyond.",
            location: "Near Amreli, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "During Navratri or other festivals",
            activities: [
                "Offer prayers to Goddess Khodiyar",
                "Attend the Aarti",
                "Participate in festivals",
                "Explore the temple architecture",
                "Enjoy the spiritual ambiance"
            ],
            mapLink: "https://maps.app.goo.gl/3zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Dariyapur Hanuman Temple",
            description: "A sacred temple dedicated to Lord Hanuman, this site is known for its peaceful ambiance and religious significance. It is a popular spot for devotees seeking blessings.",
            location: "Dariyapur, Amreli",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Offer prayers to Lord Hanuman",
                "Attend the Aarti",
                "Meditate in the serene environment",
                "Explore the temple surroundings",
                "Participate in religious events"
            ],
            mapLink: "https://maps.app.goo.gl/4zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Amreli Museum",
            description: "A small but informative museum showcasing the history, culture, and heritage of Amreli and the surrounding region. It features artifacts, sculptures, and historical exhibits.",
            location: "Amreli City Center, Amreli",
            timings: "10:00 AM to 5:00 PM (Closed on Mondays)",
            ticket: "INR 10 per person",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore historical artifacts",
                "Learn about Amreli's culture",
                "Admire ancient sculptures",
                "Take guided tours",
                "Capture photographs"
            ],
            mapLink: "https://maps.app.goo.gl/5zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Gopi Talav",
            description: "A historic lake built during the reign of the Gaekwads, Gopi Talav is a serene spot for relaxation and leisure. The lake is surrounded by lush greenery and offers a peaceful ambiance.",
            location: "Amreli City Center, Amreli",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early Morning or Evening",
            activities: [
                "Stroll around the lake",
                "Enjoy the scenic beauty",
                "Capture photographs",
                "Relax in the peaceful environment",
                "Visit nearby attractions"
            ],
            mapLink: "https://maps.app.goo.gl/6zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Shri Swaminarayan Temple",
            description: "A beautiful temple dedicated to Lord Swaminarayan, this site is known for its intricate architecture and spiritual ambiance. It is a popular destination for devotees and tourists.",
            location: "Amreli City Center, Amreli",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Offer prayers to Lord Swaminarayan",
                "Admire the temple's architecture",
                "Attend the Aarti",
                "Explore the temple surroundings",
                "Participate in religious events"
            ],
            mapLink: "https://maps.app.goo.gl/7zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Tulsishyam Temple",
            description: "A sacred temple dedicated to Lord Krishna, Tulsishyam Temple is located amidst lush greenery and natural springs. It is a popular pilgrimage site and a serene retreat for devotees.",
            location: "Near Amreli, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Offer prayers to Lord Krishna",
                "Take a dip in the natural springs",
                "Enjoy the peaceful surroundings",
                "Explore the temple architecture",
                "Participate in religious festivals"
            ],
            mapLink: "https://maps.app.goo.gl/8zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Sasangir Wildlife Sanctuary",
            description: "A lesser-known wildlife sanctuary near Amreli, Sasangir is home to diverse flora and fauna, including deer, antelopes, and various bird species. It is a great spot for nature lovers and wildlife enthusiasts.",
            location: "Near Amreli, Gujarat",
            timings: "8:00 AM to 6:00 PM",
            ticket: "INR 100 for adults, INR 50 for children",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Go on a wildlife safari",
                "Observe diverse bird species",
                "Enjoy nature walks",
                "Capture photographs",
                "Learn about wildlife conservation"
            ],
            mapLink: "https://maps.app.goo.gl/9zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Bileshwar Mahadev Temple",
            description: "An ancient temple dedicated to Lord Shiva, Bileshwar Mahadev Temple is known for its spiritual significance and historical architecture. It is a peaceful destination for devotees and history enthusiasts.",
            location: "Near Amreli, Gujarat",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Offer prayers to Lord Shiva",
                "Admire the temple's architecture",
                "Attend the Aarti",
                "Explore the temple surroundings",
                "Participate in religious festivals"
            ],
            mapLink: "https://maps.app.goo.gl/0zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Amreli Clock Tower",
            description: "A historic landmark in the heart of Amreli, the Clock Tower is a symbol of the city's heritage and culture. It is a popular spot for photography and sightseeing.",
            location: "Amreli City Center, Amreli",
            timings: "Open 24 hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Admire the historic architecture",
                "Capture photographs",
                "Explore the surrounding area",
                "Learn about the city's history",
                "Enjoy the bustling city vibe"
            ],
            mapLink: "https://maps.app.goo.gl/1zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Rampara Wildlife Sanctuary",
            description: "A serene wildlife sanctuary located near Amreli, Rampara is home to diverse flora and fauna, including deer, antelopes, and various bird species. It is a great destination for nature lovers and wildlife enthusiasts.",
            location: "Near Amreli, Gujarat",
            timings: "8:00 AM to 6:00 PM",
            ticket: "INR 100 for adults, INR 50 for children",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Go on a wildlife safari",
                "Observe diverse bird species",
                "Enjoy nature walks",
                "Capture photographs",
                "Learn about wildlife conservation"
            ],
            mapLink: "https://maps.app.goo.gl/2zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Gayatri Mandir",
            description: "A sacred temple dedicated to Goddess Gayatri, this site is known for its spiritual significance and peaceful ambiance. It is a popular destination for devotees seeking blessings.",
            location: "Amreli City Center, Amreli",
            timings: "6:00 AM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Offer prayers to Goddess Gayatri",
                "Attend the Aarti",
                "Meditate in the serene environment",
                "Explore the temple surroundings",
                "Participate in religious events"
            ],
            mapLink: "https://maps.app.goo.gl/3zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Dhari Waterfall",
            description: "A picturesque waterfall located near Amreli, Dhari Waterfall is a hidden gem for nature lovers. The waterfall is surrounded by lush greenery and offers a refreshing retreat.",
            location: "Near Amreli, Gujarat",
            timings: "Open 24 hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Monsoon Season",
            activities: [
                "Enjoy the scenic beauty",
                "Take a dip in the waterfall",
                "Capture photographs",
                "Have a picnic",
                "Explore the surrounding area"
            ],
            mapLink: "https://maps.app.goo.gl/4zX9Y7Q1yJz3y3Q8",
        },
        {
            name: "Amreli Fort",
            description: "A historic fort located in the heart of Amreli, this site is a testament to the city's rich history and architectural heritage. The fort offers a glimpse into the region's past and is a popular spot for history enthusiasts.",
            location: "Amreli City Center, Amreli",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Afternoon",
            activities: [
                "Explore the fort's architecture",
                "Learn about the city's history",
                "Capture photographs",
                "Enjoy the panoramic views",
                "Visit nearby attractions"
            ],
            mapLink: "https://maps.app.goo.gl/5zX9Y7Q1yJz3y3Q8",
        }
    ]
};